import { useDispatch } from 'react-redux';
import { restore } from '../../features/undo/thunks/restore.thunk';
import { undo } from '../../features/undo/thunks/undo.thunk';
import { useKeyboard } from './useKeyboard';

export const useUndo = () => {
  const dispatch = useDispatch();

  useKeyboard('keydown', 'z', (event) => {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();
      if (event.shiftKey) {
        dispatch(restore());
      } else {
        dispatch(undo());
      }
    }
  });
};
